<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Terms" :submit="submit"
    :status="status" :breadcrumbs="[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/spot_helps'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider ref="spot_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Lugar</div>
                <v-select solo hide-details="auto" class="input-base" append-icon="$caretDownFormIcon"
                  :error-messages="errors" v-model="data.spot_id" :items="spots" item-text="address" item-value="id"
                  label="Lugar"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="rent_order_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Orden de Alquiler</div>
                <v-select solo hide-details="auto" class="input-base" append-icon="$caretDownFormIcon"
                  :error-messages="errors" v-model="data.rent_order_id" :items="rent_orders" item-text="id"
                  item-value="id" label="Orden de Alquiler"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="help_option_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Opciones de Ayuda</div>
                <v-select solo hide-details="auto" class="input-base" append-icon="$caretDownFormIcon"
                  :error-messages="errors" v-model="data.help_option_id" :items="help_options" item-text="title"
                  item-value="id" label="Opciones de Ayuda"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Comment</div>
                <v-textarea :error-messages="errors" v-model="data.comment" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Imagen</div>
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen"
                  prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedPicture">
                </Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  created() {
    this.getAllSpots();
    this.getAllRentOrder();
    this.getAllHelpOptions();
  },
  data() {
    return {
      storeName: "Spot_helps",
      title: "Reporte de Ayuda",
      filteredAttributes: ["picture"],
      picture: "",
      data: {
        spot_id: null,
        rent_order_id: null,
        help_option_id: null,
        comment: null,
        picture: null
      }
    };
  },
  computed: {
    ...mapState({
      status: state => state.Terms.status,
      spots: state => state.Spots.list,
      rent_orders: state => state.Rent_orders.list,
      help_options: state => state.Help_options.list
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      getAllSpots: "Spots/getListAll",
      getAllRentOrder: "Rent_orders/getListAll",
      getAllHelpOptions: "Help_options/getListAll"
    }),
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture = fr.result;
      };
      fr.onerror = function () {
        self.picture = '';
      };
      fr.readAsDataURL(this.data.picture);
    }
  }
};
</script>
